import { ActionIcon, Box, Group, Title } from "@mantine/core";
import { IconPencil } from "@tabler/icons-react";
import { useState } from "react";
import { useParams } from "react-router";
import { useManagerVariant } from "../../hooks/useManagerVariant";
import { useSitesDetail } from "../../hooks/useSitesDetail";
import { LoadOrError } from "../LoadOrError/LoadOrError";
import { SiteModal } from "../MsmProjectView/Sites/SiteModal";

interface SiteAddressProps {
  siteId: number;
}

function SiteAddress({ siteId }: SiteAddressProps) {
  const {
    data: site,
    error: siteError,
    isLoading: siteIsLoading
  } = useSitesDetail(siteId);

  const { projectId } = useParams();
  const { variantId } = useManagerVariant(projectId);

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Box className="SiteAddress" mb="md">
      <LoadOrError error={siteError} loading={siteIsLoading}>
        {variantId && site && (
          <>
            <Title fw={500} order={3}>
              {site.name}
            </Title>
            <Group gap="xs">
              {formatAddress({
                street: site.address,
                city: site.city,
                zip: site.zip
              })}
              <ActionIcon
                aria-label="Adresse bearbeiten"
                color="black"
                size="sm"
                variant="transparent"
                onClick={() => setIsModalOpen(true)}
              >
                <IconPencil size="16" />
              </ActionIcon>
            </Group>
            <SiteModal
              headerText="Liegenschaft bearbeiten"
              isOpen={isModalOpen}
              site={site}
              variantId={variantId}
              onToggle={() => setIsModalOpen(false)}
            />
          </>
        )}
      </LoadOrError>
    </Box>
  );
}

type Address = {
  street?: string;
  city?: string;
  zip?: string;
};

function formatAddress(address: Address) {
  if (address.street && address.zip && address.city) {
    return address.street + ", " + address.zip + " " + address.city;
  } else if (address.street && address.zip) {
    return address.street + ", " + address.zip;
  } else if (address.street && address.city) {
    return address.street + ", " + address.city;
  } else if (address.zip && address.city) {
    return address.zip + " " + address.city;
  } else if (address.street) {
    return address.street;
  } else if (address.zip) {
    return address.zip;
  } else if (address.city) {
    return address.city;
  } else {
    return "Keine Adresse angegeben";
  }
}

export { SiteAddress, SiteAddressProps };
